<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Answer information"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Answer" label-position="inside">
                        <b-input v-model="answer.answer"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        name: 'AnswerForm',
        props: {
            answer: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };
</script>
